 <template>
    <div class="input-group mb-3 w-full">
        <input type="search" v-model="searchValue" class="form-control" placeholder="Find an icon or collection" aria-label="Find an icon or collection"
        aria-describedby="search-icon" @input="search" @click="clear"/>
        <span class="input-group-text" id="search-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search"
                viewBox="0 0 16 16">
                <path
                    d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
            </svg>
        </span>
    </div>
</template>

<script>
import axios from 'axios';
import throttle from 'lodash/throttle'

export default {
    props: ['groups'],
    emits: ['update:results'],
    data() {
        return {
            newResults: {
                icons: [],
                groups: [],
            },
            searchValue: "",
        };
    },
    methods: {
        search() {
            this.clear()

            if (this.searchValue == "") {
                return
            }

            this.newResults = {
                icons: [],
                groups: [],
            };

            this.fetchSearch()
        },
        fetchSearch: throttle(function () {
            axios.get(`/markers/search?query=${this.searchValue}`)
                .then(response => {
                    if (response.status == 200) {
                        this.newResults.groups = response.data.data?.collection?.flat() ?? []
                        this.newResults.icons = response.data.data?.markers?.flat() ?? []
                        this.newResults.risks = response.data.data?.risks?.flat() ?? []
                        document.querySelector("#v-pills-tabContent").classList.add('d-none')
                    }
                    this.$emit('update:results', this.newResults)
                })
                .catch(error => {
                    console.error(error)
                    this.$emit('update:results', this.newResults)
                    document.querySelector("#v-pills-tabContent").classList.remove('d-none')
                })
        }, 500, { trailing: true }),
        clear() {
            this.newResults = {
                icons: [],
                groups: [],
                risks: []
            }
            this.$emit('update:results', this.newResults);
            document.querySelector("#v-pills-tabContent").classList.remove('d-none')
        }
    },
}
</script>
